import React, { useState } from 'react';
import './pixelated_input.css';

/**
 * onEnter should be a function that takes in a string argument, and will be
 * called when the input is submitted using the enter key.
 */
const PixelatedInput = ({ placeholder, onEnter, numberFieldInfo, onChange }) => {
  const [text, setText] = useState('');

  function handleKeyUp(event) {
    if (event.key === 'Enter' && text.length > 0) {
        event.preventDefault();
        if (onEnter) {
            onEnter(text);
        }
    }
  }

  if (numberFieldInfo) {
    return <input
        autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false"
        type="number"
        className="pixelated-input"
        value={text}
        defaultValue={numberFieldInfo.default}
        min={numberFieldInfo.min}
        max={numberFieldInfo.max}
        style={{ width: '50px' }}
        onChange={((e) => {
            if (onChange) {
                onChange(e);
            }
            setText(e.target.value)
        })}
        onKeyUp={handleKeyUp}
        placeholder={placeholder}
      />
  }

  return (
      <input
        autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false"
        type="text"
        className="pixelated-input"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyUp={handleKeyUp}
        placeholder={placeholder}
      />
  );
};

export default PixelatedInput;
